/**
 * TemplateBuilder - Phase 3F
 * 
 * Re-exports the existing TemplateCreationWizard with the new name.
 * The original wizard is well-implemented and feature-complete.
 * This wrapper allows for future enhancements without breaking changes.
 */

import TemplateCreationWizard from '../../../../components/Registration/TemplateCreationWizard';

// Re-export with new name for consistency
export default TemplateCreationWizard;
